import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  getActiveRoomId,
  setActiveRoomId,
} from '../utils/api/roomPriceContext';
import { fetchDefaultPriceConfig } from '../store/actions/default.config.action';
import { roomPriceContextChanged } from '../store/actions/roomPriceContext.action';

// Bỏ dữ liệu giá đã tải theo ngữ cảnh cũ và tải lại cấu hình giá mặc định (kèm X-Room-Id hiện tại)
export const refreshRoomPriceData = dispatch => {
  dispatch(roomPriceContextChanged());
  dispatch(fetchDefaultPriceConfig({ country_code: 'vn' }));
  dispatch(fetchDefaultPriceConfig({ country_code: 'us' }));
};

/**
 * Đồng bộ room đang mở với các API đọc giá (header X-Room-Id). Khi room đổi hoặc khi rời trình thiết kế,
 * dữ liệu giá đã tải theo room cũ bị reset và cấu hình giá mặc định được tải lại; room có khách đã chốt sẽ nhận
 * giá đã chốt, các trường hợp khác nhận giá live.
 */
export default function useRoomPriceContext(roomId) {
  const dispatch = useDispatch();

  useEffect(() => {
    const next = roomId ? String(roomId) : null;
    if (getActiveRoomId() === next) return;
    setActiveRoomId(next);
    refreshRoomPriceData(dispatch);
  }, [roomId, dispatch]);

  // Rời trình thiết kế: các trang khác lại đọc giá live
  useEffect(
    () => () => {
      if (getActiveRoomId() === null) return;
      setActiveRoomId(null);
      refreshRoomPriceData(dispatch);
    },
    [dispatch]
  );
}
